import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { safeStore } from "../lib/labText";

const inputCls = "w-full bg-transparent border border-[#262421] px-4 py-3 mt-2 outline-none focus:border-[#C49A6C] transition-colors text-[#F2EBE1] text-sm";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      const next = safeStore.get("omr_next");
      safeStore.set("omr_next", "");
      navigate(user.role === "admin" ? "/admin" : next || "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-24 md:py-32">
      <h1 className="serif text-4xl text-center mb-12">{t("login")}</h1>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{t("email")}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className={inputCls} />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{t("password_label")}</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className={inputCls} />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.25em] py-4 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50">
          {loading ? "…" : t("login")}
        </button>
      </form>
      <p className="text-center text-sm text-[#8A857D] mt-8">
        {t("no_account")} <Link to="/register" className="text-[#C49A6C] link-underline">{t("register")}</Link>
      </p>
    </div>
  );
}
